import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterExpiredDiscountCodes", "objectType"];
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getEcommerceStoresRpc } from '../../__generated__/chirp/com/hubspot/website/interactive/rpc/WebsiteInteractiveStoresService';
import { getRecordsRpc } from '../../__generated__/chirp/com/hubspot/sync/health/rpc/RecordsQueryService';
import { fetchDiscountCodesForPickerRpc } from '../../__generated__/chirp/com/hubspot/shopify/integration/rpc/DiscountCodePickerServiceRpc';
import { ECOMMERCE_OBJECT_TYPES } from '../constants/ecommerce';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
function toEcommerceObjects(records) {
  return records.filter(record => record.hubSpotObjectId != null).map(record => {
    var _record$name;
    return {
      name: (_record$name = record.name) !== null && _record$name !== void 0 ? _record$name : '',
      hubSpotObjectId: record.hubSpotObjectId
    };
  });
}
export function fetchStores() {
  return rpcClient.call(getEcommerceStoresRpc, {});
}
export function fetchConnections({
  storeAccountId,
  appId
}) {
  return http.get(`sync-bridge/v3/accounts/${storeAccountId}/connections`, {
    query: {
      appId
    }
  });
}
async function fetchRecordsPage(params) {
  const {
    records,
    total,
    offset,
    hasMore
  } = await rpcClient.call(getRecordsRpc, {
    request: {
      connectionIds: params.connectionIds,
      status: ['IN_SYNC'],
      limit: params.limit,
      offset: params.offset,
      searchQuery: params.searchQuery
    }
  });
  return {
    results: toEcommerceObjects(records),
    total,
    offset,
    hasMore
  };
}
async function fetchNonExpiredDiscountCodes(params) {
  const {
    discountCodes,
    total,
    offset,
    hasMore
  } = await rpcClient.call(fetchDiscountCodesForPickerRpc, {
    request: {
      connectionId: params.connectionIds[0],
      pageSize: params.limit,
      offset: params.offset,
      searchQuery: params.searchQuery
    }
  });
  return {
    results: toEcommerceObjects(discountCodes),
    total,
    offset,
    hasMore
  };
}
export function fetchObjects(query) {
  const {
      filterExpiredDiscountCodes,
      objectType
    } = query,
    fetchQuery = _objectWithoutPropertiesLoose(query, _excluded);
  if (filterExpiredDiscountCodes && objectType === ECOMMERCE_OBJECT_TYPES.DISCOUNT_CODE) {
    return fetchNonExpiredDiscountCodes(fetchQuery);
  }
  return fetchRecordsPage(fetchQuery);
}